import { ProgressRadial, Text } from "@itwin/itwinui-react";
import styles from "./FormSpinner.module.css";

interface FormSpinnerProps {
  message?: string;
  size?: '' | 'x-small' | 'small' | 'large';
}
export const FormSpinner = ({ message, size }: FormSpinnerProps) => {
  return (
    <div className={styles.spinner}>
      <ProgressRadial indeterminate size={size} />
      {message && <Text isMuted>{message}</Text>}
    </div>
  )
};